// extracted by mini-css-extract-plugin
export default {"container":"Actus_container__p4k+1","congress":"Actus_congress__XSxAV","plans":"Actus_plans__cu3Ef","news":"Actus_news__aIF8Z","cards":"Actus_cards__n-JBq"};